import { render, staticRenderFns } from "./TgE3SearchNews.vue?vue&type=template&id=738d3ed6&"
import script from "./TgE3SearchNews.vue?vue&type=script&lang=js&"
export * from "./TgE3SearchNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports